import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/payment-reminders/rent-object-bookings/${formData.rentObjectBookingId}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/payment-reminders/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async getAttachement(formData) {
    return axios.get(`/payment-reminders/${formData.id}/pdf`, { responseType: 'arraybuffer' });
  },
  async settlementPDFPreview(formData) {
    return axios.post(`/payment-reminders/rent-object-bookings/${formData.rentObjectBookingId}/payment-reminder-pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/payment-reminders/${id}`);
  },
};